// extracted by mini-css-extract-plugin
export default {"text":"ProfilePersonal_text__o8msH","bg_profile":"ProfilePersonal_bg_profile__U-8cF"};